/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/3/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
const DN_PREFIX = "[EXTENSION_TASK]";

export { DN_PREFIX };
